import { render, staticRenderFns } from "./Investigation.vue?vue&type=template&id=7e072ef0&scoped=true&"
import script from "./Investigation.vue?vue&type=script&lang=ts&"
export * from "./Investigation.vue?vue&type=script&lang=ts&"
import style0 from "./Investigation.vue?vue&type=style&index=0&id=7e072ef0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e072ef0",
  null
  
)

export default component.exports